export const translations = {
    es: {
        app: {
            loader: 'Cargando menú...',
            error: {
                menu: 'No se pudo cargar el menú',
                theme: 'No se pudo cargar el tema',
                default: 'Ha ocurrido un error'
            }
        },
        fab: {
            menu: 'Menú',
            home: 'Inicio'
        },
        fallback: {
            product: 'Producto',
            option: 'Opción',
            section: 'Sección',
            page: 'Página'
        },
        lang: {
            missing: 'Traducción no disponible'
        },
        availability: {
            available: 'Disponible',
            unavailable: 'No disponible',
            endingSoon: '¡Termina pronto!',
            endingIn: 'Termina en {minutes} min'
        },
        modifiers: {
            required: 'Requerido',
            optional: 'Opcional',
            select: 'Seleccionar',
            minSelect: 'Mínimo {count}',
            maxSelect: 'Máximo {count}'
        },
        actions: {
            share: 'Compartir',
            close: 'Cerrar',
            retry: 'Reintentar',
            scrollDown: 'Desliza hacia abajo'
        },
        offline: {
            title: 'Sin conexión',
            message: 'No pudimos cargar el menú. Por favor, verifica tu conexión a internet e intenta de nuevo.'
        }
    },
    en: {
        app: {
            loader: 'Loading menu...',
            error: {
                menu: 'Could not load menu',
                theme: 'Could not load theme',
                default: 'An error occurred'
            }
        },
        fab: {
            menu: 'Menu',
            home: 'Home'
        },
        fallback: {
            product: 'Product',
            option: 'Option',
            section: 'Section',
            page: 'Page'
        },
        lang: {
            missing: 'Translation not available'
        },
        availability: {
            available: 'Available',
            unavailable: 'Not available',
            endingSoon: 'Ending soon!',
            endingIn: 'Ends in {minutes} min'
        },
        modifiers: {
            required: 'Required',
            optional: 'Optional',
            select: 'Select',
            minSelect: 'Min {count}',
            maxSelect: 'Max {count}'
        },
        actions: {
            share: 'Share',
            close: 'Close',
            retry: 'Retry',
            scrollDown: 'Scroll down'
        },
        offline: {
            title: 'Offline',
            message: 'We could not load the menu. Please check your internet connection and try again.'
        }
    }
};
